import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'selectedTenantId';

/**
 * Company a SUPERADMIN is working on. Sent as `X-Tenant-Id`; the backend only
 * honors it for superadmins (a B2B admin always works on the company of its
 * token). `null` = the platform (B2C) tenant, the backend default.
 * Kept in sessionStorage, so it is per tab and cleared with the session.
 */
@Injectable({ providedIn: 'root' })
export class TenantSelectionService {
  private readonly selected = signal<number | null>(readStored());

  public readonly tenantId = this.selected.asReadonly();

  public select(tenantId: number | null): void {
    this.selected.set(tenantId);
    try {
      if (tenantId === null) {
        sessionStorage.removeItem(STORAGE_KEY);
      } else {
        sessionStorage.setItem(STORAGE_KEY, String(tenantId));
      }
    } catch {
      // Storage unavailable (private mode): the selection lives until reload.
    }
  }
}

function readStored(): number | null {
  try {
    const id = Number(sessionStorage.getItem(STORAGE_KEY));
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}
